import { Box, Flex, Text } from '@chakra-ui/react';

import { OutlineCard } from '@morressier/alembic';

const ReviewerActivityNotFound = () => {
  return (
    <OutlineCard borderless width="100%" paddingY={3} paddingX={4}>
      <Flex gap={4}>
        <Box>
          <Text textStyle="textBody">Reviewer Activity Not Found</Text>
        </Box>
      </Flex>
    </OutlineCard>
  );
};

export default ReviewerActivityNotFound;
